import { execFileSync } from 'child_process';
import { createCertificate } from './createCertificate.js';
import path from 'path';
import { defaultPassphrase } from './defaultPassphrase.js';
import { getValidDomains } from './getValidDomains.js';

const scriptsDir = path.resolve(import.meta.dirname, '../scripts');
const windowsScript = path.join(scriptsDir, 'webapp-setup.ps1');
const bashScript = path.join(scriptsDir, 'webapp-setup.sh');

export async function setup(options: {
  domain: undefined | string | string[];
  cwd: string;
  shouldCreateCertificate: boolean;
}): Promise<void> {
  const { shouldCreateCertificate, domain } = options;

  const domains = getValidDomains(domain);
  if (!domains.length && !shouldCreateCertificate) {
    return;
  }

  const isWindows = process.platform === 'win32';
  if (!isWindows && process.platform !== 'linux' && process.platform !== 'darwin') {
    throw Error(`Unsupported OS: ${process.platform}`);
  }

  let certPath: string | undefined;
  if (shouldCreateCertificate) {
    ({ certPath } = await createCertificate(options));
  }

  if (isWindows) {
    logAndExecute('powershell', [
      '-NoProfile',
      '-ExecutionPolicy',
      'ByPass',
      '-File',
      windowsScript,
      ...(certPath ? ['-CertPath', certPath] : []),
      ...(domains.length ? ['-Domains', domains.join(',')] : []),
    ]);
  } else {
    logAndExecute('bash', [
      bashScript,
      ...(certPath ? ['--CertPath', certPath] : []),
      ...(certPath ? ['--Passphrase', defaultPassphrase] : []),
      ...(domains.length ? ['--Domains', domains.join(',')] : []),
    ]);
  }
}

const logAndExecute = (command: string, args: string[]): void => {
  console.log(`Running: ${command} ${args.join(' ')}`);

  execFileSync(command, args, {
    stdio: 'inherit',
    cwd: import.meta.dirname,
    windowsHide: true,
    shell: false,
  });
};
